import { createMultiStyleConfigHelpers as a } from "@chakra-ui/styled-system";
const e = a([
  "banner",
  "wrapper",
  "media",
  "content"
]), i = e.defineMultiStyleConfig({
  baseStyle: ({ theme: n }) => ({
    banner: {
      display: "flex",
      maxHeight: {
        sm: n.banner.tabletStandard,
        md: n.banner.desktopStandardHeight
      },
      position: "relative",
      px: {
        base: 0,
        md: n.bannerContentPaddingTablet,
        lg: n.bannerContentPaddingDesktop
      }
    },
    wrapper: {
      display: "flex",
      height: {
        sm: n.banner.tabletStandard,
        md: n.banner.desktopStandardHeight
      },
      margin: "auto",
      flexDirection: { base: "column-reverse", sm: "row" },
      px: {
        base: 0,
        sm: n.siteMargin.smDefault,
        md: n.siteMargin.lgDefault,
        xl: n.siteMargin.xlgDefault
      }
    },
    content: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      backgroundColor: n.background.mid,
      p: {
        base: n.bannerContentPaddingMobile,
        sm: 0
      },
      pl: {
        base: n.bannerContentPaddingDesktop,
        sm: n.bannerContentPaddingMobile,
        md: n.bannerContentPaddingTablet,
        lg: n.bannerContentPaddingDesktop
      },
      paddingTop: "0",
      rowGap: {
        base: n.bannerTextSpacingMobileLarge,
        sm: n.bannerTextSpacingTabletLarge,
        lg: n.bannerTextSpacingDesktopLarge
      },
      a: {
        textDecoration: "underline"
      },
      "a.promo-btn": {
        textDecoration: "none"
      },
      img: {
        height: n.bannerLogoHeight
      },
      "& * a.cta-link": {
        color: n.action.primaryDefault
      },
      "& * a.cta-link:hover": {
        textDecoration: "none",
        color: n.action.primaryHover
      },
      ".badges-text-content": {
        flexDirection: "column",
        rowGap: {
          base: n.bannerTextSpacingMobileLarge,
          sm: n.bannerTextSpacingTabletLarge,
          lg: n.bannerTextSpacingDesktopLarge
        }
      },
      ".logo-text-content": {
        flexDirection: "column",
        rowGap: {
          base: n.bannerTextSpacingMobileSmall,
          sm: n.bannerTextSpacingTabletSmall,
          lg: n.bannerTextSpacingDesktopSmall
        }
      }
    },
    media: {
      position: { base: "relative" },
      minHeight: n.localTokens.bannerImageMinHeight,
      justifyContent: "center",
      display: "flex",
      flex: 1,
      img: {
        objectFit: "cover",
        height: "auto",
        width: "100%"
      }
    }
  }),
  variants: {
    // Fixed: Standard Banner with fixed image
    fixed: ({ theme: n }) => ({
      content: {
        flex: 1
      },
      media: {
        justifyContent: "flex-end",
        height: "inherit",
        img: {
          objectFit: "contain"
        },
        pr: {
          base: n.bannerContentPaddingMobile,
          sm: 0
        },
        pl: {
          base: n.bannerContentPaddingMobile,
          sm: n.bannerContentSpacingTablet
        },
        pb: {
          base: n.bannerContentSpacingMobile,
          sm: n.bannerContentSpacingTablet
        },
        pt: {
          base: n.bannerContentSpacingMobile,
          sm: n.bannerContentSpacingTablet
        }
      }
    }),
    // Full: Standard Banner with Absolute positioned image which can flow out of the container
    full: ({ theme: n }) => ({
      content: {
        width: { sm: "50%", xl: "59%" },
        pr: { sm: n.bannerContentSpacingDesktop }
      },
      media: {
        margin: "0",
        position: { sm: "absolute" },
        width: { base: "100vw", sm: "50%", xl: "41%" },
        right: { sm: 0 },
        top: { sm: 0 },
        bottom: { sm: 0 },
        height: "auto",
        justifyContent: { base: "center", sm: "flex-end", xl: "flex-start" },
        // change as part of HFE-521
        paddingBottom: {
          base: n.bannerTextSpacingMobileLarge,
          sm: "0"
        }
      }
    }),
    // Only Image: Standard Banner with just an image
    onlyImage: () => ({}),
    // Headline: Standard banner to be used within the page
    headline: ({ theme: n }) => ({
      banner: {
        backgroundColor: "transparent"
      },
      content: {
        width: { sm: "50%" },
        pr: { sm: n.bannerContentSpacingDesktop },
        pl: {
          sm: n.siteMargin.xsmDefault,
          md: n.siteMargin.lgDefault,
          xl: n.siteMargin.xlgDefault
        },
        paddingTop: {
          base: n.bannerTextSpacingMobile,
          sm: "0"
        }
      },
      media: {
        margin: "0",
        width: { base: "100vw", sm: "50%" },
        justifyContent: { base: "center", sm: "flex-end" }
      }
    })
  },
  defaultProps: {
    variant: "fixed"
  }
});
export {
  i as default
};
